import { useNavigate } from 'react-router-dom';
import { Grid, IconButton, Tooltip } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

import { NoResults } from "../../common/utils/notDataUtils"
import CatalogButton from '../button/catalogButton';
import SearchBar from "../menuBar/searchBar"

function CatalogCard({ icons, catalog, category = null }) {
    /** CONST */
    const navigate = useNavigate();
    const uri = category ? `catalog/${category}` : 'catalog';
    const sx = {
        alignItems: "center",
    }
    /** FUNCTIONS */
    const navigateToCatalog = () => {
        navigate(`/catalog`);
    }

    return (
        <>
            {!category &&
                <div className='row d-flex justify-content-center'>
                    <div className='col-md-6 my-3'>
                        <SearchBar placeholder={"Buscar modelo"} />
                    </div>
                </div>
            }
            {category &&
                <Grid className='mt-4'>
                    <Tooltip title="Volver a categorías">
                        <IconButton onClick={navigateToCatalog}>
                            <ArrowBack fontSize="large" />
                        </IconButton>
                    </Tooltip>
                </Grid>
            }
            <Grid container sx={sx} className="card-row">
                {catalog && catalog.map((item, index) => {
                    return (
                        <Grid key={index} item sm={6} md={4} lg={4} sx={{ p: 2 }} className='col-10' id="catalog-button-grid">
                            <CatalogButton
                                allowEdit={false}
                                itemInfo={{
                                    code: item.code,
                                    title: item.name,
                                    name: item.name,
                                    reference: icons.find(obj => obj.id === item.reference)
                                }}
                                uri={uri}
                            />
                        </Grid>
                    );
                })}
                {(!catalog || catalog.length < 1) &&
                    <NoResults
                        text={'No se encontraron equipos para ' + (catalog ? 'esta categoria' : 'este catálogo')}
                    />
                }
            </Grid>
        </>
    );
}

export default CatalogCard